import React, { useEffect } from 'react'
import circle from '../../../images/main/curcle.svg'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import smoothscroll from 'smoothscroll-polyfill'

const PrivacyPolicy = ({ ourRef }) => {
  smoothscroll.polyfill()
  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <Link to='/' className={styles.left_wrap}>
          <span>&larr;</span>Вернуться назад
        </Link>
        <p>Политика в отношении обработки персональных данных</p>
      </div>
      <div className={styles.right}>
        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>1. Общие положения</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              1.1. Настоящая политика обработки персональных данных составлена в соответствии с требованиями
              Федерального закона от 27.07.2006. No152-ФЗ «О персональных данных» (далее — Закон о персональных данных)
              и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных,
              предпринимаемые Акционерным обществом «ГЕНЕРИУМ» (далее — Оператор).
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              1.2. Оператор ставит своей целью и условием осуществления своей деятельности соблюдение прав и свобод
              человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность
              частной жизни, личную и семейную тайну.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              1.3. Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется
              ко всей информации, которую Оператор может получить о посетителях веб-сайта <a style={{ color: 'blue' }} href='https://career.generium.ru/'>https://career.generium.ru/</a>.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              1.4. Оператор обязан опубликовать или иным образом обеспечить неограниченный доступ к настоящей Политике
              обработки персональных данных в соответствии сч. 2 ст. 18.1. Закона о персональных данных.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>2. Основные понятия</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Персональные данные — любая информация, относящаяся к прямо или косвенно определенному или определяемому
              физическому лицу (субъекту персональных данных).
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Субъект персональных данных (Субъект) — физическое лицо, которое прямо или косвенно определено или
              определяемо с помощью персональных данных.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Оператор персональных данных (Оператор) — Акционерное общество «ГЕНЕРИУМ», самостоятельно или совместно с
              другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие
              цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции),
              совершаемые с персональными данными.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Обработка персональных данных — любое действие (операция) или совокупность действий (операций) с
              персональными данными, совершаемых с использованием средств автоматизации или без их использования.
              Обработка персональных данных включает в себя, в том числе: сбор, запись, систематизацию, накопление,
              хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение,
              предоставление, доступ), обезличивание, блокирование, удаление, уничтожение.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств
              вычислительной техники.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Распространение персональных данных — действия, направленные на раскрытие персональных данных
              неопределённому кругу лиц.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' draggable='false' />
            <p>
              Предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному
              лицу или определенному кругу лиц.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Блокирование персональных данных — временное прекращение обработки персональных данных (за исключением
              случаев, если обработка необходима для уточнения персональных данных).
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Уничтожение персональных данных — действия, в результате которых становится невозможным восстановить
              содержание персональных данных в информационной системе персональных данных и (или) в результате которых
              уничтожаются материальные носители персональных данных.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Обезличивание персональных данных — действия, в результате которых становится невозможным без
              использования дополнительной информации определить принадлежность персональных данных конкретному субъекту
              персональных данных.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных
              и обеспечивающих их обработку информационных технологий и технических средств.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              Трансграничная передача персональных данных — передача персональных данных на территорию иностранного
              государства органу власти иностранного государства, иностранному физическому лицу или иностранному
              юридическому лицу.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>3. Основные права и обязанности Оператора</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>3.1. Оператор в праве:</p>
              <ol>
                <li>
                  самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения
                  обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним
                  нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими
                  федеральными законами;
                </li>
              </ol>
              <ol>
                <li>
                  поручить обработку персональных данных другому лицу с согласия субъекта персональных данных, если иное
                  не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо,
                  осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и
                  правила обработки персональных данных, предусмотренные Законом о персональных данных и настоящей
                  Политикой;
                </li>
              </ol>
              <ol>
                <li>
                  в случае отзыва Субъектом персональных данных согласия на обработку персональных данных, Оператор
                  вправе продолжить обработку персональных данных без согласия субъекта персональных данных в случаях,
                  указанных в Законе о персональных данных.
                </li>
              </ol>
            </div>

            <div className={styles.right_wrap_li}>
              <img className={styles.right_wrap_li_img} src={circle} alt='circle' />
              <p>3.2. Оператор обязан:</p>
              <ol>
                <li>
                  обрабатывать персональные данные в порядке, установленном действующим законодательством Российской
                  Федерации;
                </li>
              </ol>
              <ol>
                <li>
                  рассматривать и отвечать на обращения Субъекта (его законного представителя) по вопросам обработки
                  персональных данных и давать мотивированные ответы;
                </li>
              </ol>
              <ol>
                <li>
                  предоставлять Субъекту (его законному представителю) возможность безвозмездного доступа к его
                  персональным данным;
                </li>
              </ol>
              <ol>
                <li>
                  принимать меры по уточнению, уничтожению персональных данных Субъекта в связи с его (его законного
                  представителя) обращением с законными и обоснованными требованиями;
                </li>
              </ol>
              <ol>
                <li>
                  обеспечивать защиту персональных данных от неправомерного или случайного доступа к ним, уничтожения,
                  изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от
                  иных неправомерных действий в отношении персональных данных в соответствии с требованиями
                  законодательства РФ.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>4. Основные права и обязанности Субъекта</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>4.1. Субъект обладает следующими правами:</p>
              <ol>
                <li>
                  получать информацию, касающуюся обработки его персональных данных Оператором, а также персональных
                  данных, обрабатываемых по поручению Оператора, в объеме и в порядке предусмотренном Законом о
                  персональных данных и принятыми в соответствии с ним нормативными правовыми актами;
                </li>
              </ol>
              <ol>
                <li>определять своих представителей для защиты своих персональных данных;</li>
              </ol>
              <ol>
                <li>
                  требовать от Оператора уточнения его персональных данных, их блокирования или уничтожения в случае,
                  если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не
                  являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по
                  защите своих прав;
                </li>
              </ol>
              <ol>
                <li>
                  требовать извещения Оператором всех лиц, которым ранее были сообщены неверные или неполные
                  персональные данные, обо всех произведенных в них исключениях, исправлениях или дополнениях;
                </li>
              </ol>
              <ol>
                <li>
                  получать свободный бесплатный доступ к своим персональным данным, включая право на получение копий
                  любой записи, содержащей персональные данные субъекта персональных данных, за исключением случаев,
                  предусмотренных законодательством Российской Федерации;
                </li>
              </ol>
              <ol>
                <li>отозвать согласие на обработку персональных данных;</li>
              </ol>
              <ol>
                <li>
                  обжаловать в суде любые неправомерные действия или бездействие Оператора при обработке и защите его
                  персональных данных;
                </li>
              </ol>
              <ol>
                <li>иными правами, предусмотренными законодательством РФ</li>
              </ol>
            </div>

            <div className={styles.right_wrap_li}>
              <img className={styles.right_wrap_li_img} src={circle} alt='circle' />
              <p>4.2 Субъект обязан:</p>
              <ol>
                <li>предоставлять Оператору только достоверные данные о себе;</li>
              </ol>
              <ol>
                <li>
                  предоставлять документы, содержащие персональные данные в объеме, необходимом для целей обработки;
                </li>
              </ol>
              <ol>
                <li>своевременно сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>6. Цели, принципы сбора персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              6.1. Обработка персональных данных Оператором ограничивается достижением конкретных, заранее определенных
              и законных целей.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>6.2. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.</p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              6.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых
              осуществляется в целях, несовместимых между собой.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>6.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              6.5. Содержание и объем обрабатываемых персональных данных должны соответствовать заявленным целям
              обработки. Обрабатываемые персональные данные не должны быть избыточными по отношению к заявленным целям
              их обработки.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              6.6. При обработке персональных данных должны быть обеспечены точность персональных данных, их
              достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных.
              Оператор принимает необходимые меры по удалению или уточнению неполных или неточных данных.
            </p>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              6.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных
              данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных
              данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или
              поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные подлежат
              уничтожению либо обезличиванию по достижении целей обработки или в случае утраты необходимости в
              достижении этих целей, если иное не предусмотрено федеральным законом.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>7. Условия, принципы, цели обработки персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                7.1. Оператор производит обработку персональных данных при наличии хотя бы одного из следующих условий:
              </p>
              <ol>
                <li>
                  обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его
                  персональных данных;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для достижения целей, предусмотренных международным договором
                  Российской Федерации или законом, для осуществления и выполнения возложенных законодательством
                  Российской Федерации на оператора функций, полномочий и обязанностей;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных осуществляется в связи с участием лица в конституционном, гражданском,
                  административном, уголовном судопроизводстве, судопроизводстве в арбитражных судах;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для исполнения судебного акта, акта другого органа или
                  должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об
                  исполнительном производстве (далее — исполнение судебного акта);
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для исполнения полномочий федеральных органов исполнительной
                  власти, органов государственных внебюджетных фондов, исполнительных органов государственной власти
                  субъектов Российской Федерации, органов местного самоуправления и функций организаций, участвующих в
                  предоставлении соответственно государственных и муниципальных услуг, предусмотренных Федеральным
                  законом от 27 июля 2010 года № 210-ФЗ «Об организации предоставления государственных и муниципальных
                  услуг», включая регистрацию субъекта персональных данных на едином портале государственных и
                  муниципальных услуг и (или) региональных порталах государственных и муниципальных услуг;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для исполнения договора, стороной которого либо
                  выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для
                  заключения договора по инициативе субъекта персональных данных или договора, по которому субъект
                  персональных данных будет являться выгодоприобретателем или поручителем;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для защиты жизни, здоровья или иных жизненно важных интересов
                  субъекта персональных данных, если получение согласия субъекта персональных данных невозможно;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для осуществления прав и законных интересов оператора или
                  третьих лиц;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для достижения общественно значимых целей при условии, что
                  при этом не нарушаются права и свободы субъекта персональных данных;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для осуществления научной, литературной или иной творческой
                  деятельности при условии, что при этом не нарушаются права и законные интересы субъекта персональных
                  данных;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных осуществляется в статистических или иных исследовательских целях, за
                  исключением целей, указанных в статье 15 Федерального закона О защите персональных данных, при условии
                  обязательного обезличивания персональных данных;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных, полученных в результате обезличивания персональных данных,
                  осуществляется в целях повышения эффективности государственного или муниципального управления, а также
                  в иных целях, предусмотренных Федеральным законом «О проведении эксперимента по установлению
                  специального регулирования в целях создания необходимых условий для разработки и внедрения технологий
                  искусственного интеллекта в субъекте Российской Федерации — городе федерального значения Москве и
                  внесении изменений в статьи 6 и 1 О Федерального закона „О персональных данных“, в порядке и на
                  условиях, которые предусмотрены указанным Федеральным законом»;
                </li>
              </ol>
              <ol>
                <li>
                  осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в
                  соответствии с федеральным законом.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>8. Конфиденциальность персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <p>
              8.1. Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и
              не распространять персональные данные без согласия субъекта персональных данных, если иное не
              предусмотрено федеральным законом.
            </p>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>9. Правовое основание обработки персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                9.1. Правовым основанием обработки персональных данных является совокупность правовых актов, во
                исполнение которых и в соответствии с которыми Оператор осуществляет обработку персональных данных.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>9.2. В качестве правового основания обработки персональных данных могут быть:</p>
              <ol>
                <li>
                  федеральные законы и принятые на их основе нормативные правовые акты, регулирующие отношения,
                  связанные с деятельностью оператора;
                </li>
              </ol>
              <ol>
                <li>уставные документы оператора;</li>
              </ol>
              <ol>
                <li>договоры, заключаемые между оператором и субъектом персональных данных;</li>
              </ol>
              <ol>
                <li>
                  согласие на обработку персональных данных (в случаях, прямо не предусмотренных законодательством
                  Российской Федерации, но соответствующих полномочиям оператора);
                </li>
              </ol>
              <ol>
                <li>иные правовые основания, предусмотренные законодательством.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>
            10. Объем и категории обрабатываемых персональных данных, категории субъектов персональных данных
          </p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                10.1. Содержание и объем обрабатываемых персональных данных должны соответствовать заявленным целям
                обработки. Обрабатываемые персональные данные не должны быть избыточными по отношению к заявленным целям
                их обработки.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>10.2. К категориям субъектов персональных данных могут быть отнесены, в том числе:</p>
              <ol>
                <li>
                  работники Оператора, бывшие работники, кандидаты на замещение вакантных должностей, а также
                  родственники работников;
                </li>
              </ol>
              <ol>
                <li>
                  лица, участвующие в конкурсе на замещение вакантной должности или на формирование кадрового резерва;
                </li>
              </ol>
              <ol>
                <li>клиенты и контрагенты Оператора (физические лица);</li>
              </ol>
              <ol>
                <li>представители или работники клиентов и контрагентов Оператора (юридических лиц).</li>
              </ol>
              <ol>
                <li>
                  посетители сайта Оператора (далее — Сайт){' '}
                  <a style={{ color: 'blue' }} href='https://career.generium.ru/'>
                    https://career.generium.ru/
                  </a>
                </li>
              </ol>
              <ol>
                <li>субъекты клинических исследований лекарственных препаратов;</li>
              </ol>
              <ol>
                <li>
                  пациенты в рамках осуществления оператором обязанности, предусмотренной законодательством, в отношении
                  мониторинга безопасности лекарственных средств (фармаконадзор).
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>11. Общедоступные источники персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11.1. В целях информационного обеспечения у Оператора могут создаваться общедоступные источники
                персональных данных субъектов персональных данных, в том числе справочники и адресные книги.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11.2. В общедоступные источники персональных данных с письменного согласия субъекта персональных данных
                могут включаться:
              </p>
              <ol>
                <li>его фамилия;</li>
              </ol>
              <ol>
                <li>имя, отчество;</li>
              </ol>
              <ol>
                <li>дата и место рождения;</li>
              </ol>
              <ol>
                <li>должность;</li>
              </ol>
              <ol>
                <li>номера контактных телефонов;</li>
              </ol>
              <ol>
                <li>адрес электронной почты и иные персональные данные, сообщаемые субъектом персональных данных.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11.3. Сведения о субъекте персональных данных должны быть в любое время исключены из общедоступных
                источников персональных данных по требованию субъекта персональных данных, уполномоченного органа по
                защите прав субъектов персональных данных либо по решению суда.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>12. Специальные категории персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                12.1. Обработка Оператором специальных категорий персональных данных осуществляется в случаях,
                предусмотренных законодательством.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                12.2. Обработка специальных категорий персональных данных, осуществлявшаяся в случаях, предусмотренных
                пунктом 4 статьи 1 О ФЗ-152 О персональных данных и должна быть незамедлительно прекращена, если
                устранены причины, вследствие которых осуществлялась их обработка, если иное не установлено федеральным
                законом.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                12.3. Биометрические персональные данные могут обрабатываться Оператором только при наличии согласия
                субъекта персональных данных в письменной форме.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>13. Поручение обработки персональных данных другому лицу</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                13.1. Оператор вправе поручить обработку персональных данных другому лицу с согласия субъекта
                персональных данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим
                лицом договора.
              </p>
            </div>
          </div>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                13.2. Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать
                принципы и правила обработки персональных данных, предусмотренные ФЗ-152 и настоящей Политикой.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>14. Обработка персональных данных граждан Российской Федерации</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                14.1. В соответствии со статьей 2 Федерального закона от 21 июля 2014 года N 242-ФЗ «О внесении
                изменений в отдельные законодательные акты Российской Федерации в части уточнения порядка обработки
                персональных данных в информационно телекоммуникационных сетях» при сборе персональных данных, в том
                числе посредством информационно-телекоммуникационной сети «Интернет», оператор обязан обеспечить запись,
                систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных
                граждан Российской Федерации с использованием баз данных, находящихся на территории Российской
                Федерации, за исключением случаев, когда:
              </p>
              <ol>
                <li>
                  обработка персональных данных необходима для достижения целей, предусмотренных международным договором
                  Российской Федерации или законом, для осуществления и выполнения возложенных законодательством
                  Российской Федерации на Оператора функций, полномочий и обязанностей; - обработка персональных данных
                  необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или
                  должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об
                  исполнительном производстве (далее — исполнение судебного акта);
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для исполнения полномочий федеральных органов исполнительной
                  власти, органов государственных внебюджетных фондов, исполнительных органов государственной власти
                  субъектов Российской Федерации, органов местного самоуправления и функций организаций, участвующих в
                  предоставлении соответственно государственных и муниципальных услуг, предусмотренных Федеральным
                  законом от 27 июля 2010 года N 210-ФЗ «Об организации предоставления государственных и муниципальных
                  услуг», включая регистрацию субъекта персональных данных на едином портале государственных и
                  муниципальных услуг и (или) региональных порталах государственных и муниципальных услуг;
                </li>
              </ol>
              <ol>
                <li>
                  обработка персональных данных необходима для осуществления профессиональной деятельности журналиста и
                  (или) законной деятельности средства массовой информации либо научной, литературной или иной
                  творческой деятельности при условии, что при этом не нарушаются права и законные интересы субъекта
                  персональных данных.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>15. Трансграничная передача персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                15.1. Оператор обязан убедиться в том, что иностранным государством, на территорию которого
                предполагается осуществлять передачу персональных данных, обеспечивается адекватная защита прав
                субъектов персональных данных, до начала осуществления такой передачи.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                15.2. Трансграничная передача персональных данных на территории иностранных государств, не
                обеспечивающих адекватной защиты прав субъектов персональных данных, может осуществляться в случаях:
              </p>
              <ol>
                <li>
                  наличия согласия в письменной форме субъекта персональных данных на трансграничную передачу его
                  персональных данных;
                </li>
              </ol>
              <ol>
                <li>исполнения договора, стороной которого является субъект персональных данных.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_p}>
            16. Уточнение персональных данных, отзыв согласия на обработку персональных данных
          </p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                16.1. Субъект персональных данных вправе направить запрос Оператору на актуализацию, исправление,
                удаление и уничтожение персональных по адресу: 601125, Владимирская область, Петушинский район,
                п.Вольгинский, ул. Заводская, стр. 273, а также путем направления письменного заявления{' '}
                <a style={{ color: 'blue' }} href='mailto:career@generium.ru'>
                  career@generium.ru
                </a>
                .
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                16.2. В случае подтверждения факта неточности персональных данных или неправомерности их обработки,
                персональные данные подлежат их актуализации оператором, а обработка должна быть прекращена,
                соответственно.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_title}>Приложение № 1 к Политике обработки персональных данных</p>
          <p className={styles.right_item1_p}>Согласие на обработку персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Лицо, заполняющее контактную форму, размещенную на настоящем ресурсе, для целей участия в конкурсе на
                вакантную должность, настоящим дает компании АО «Генериум» (далее - «Общество»), зарегистрированному по
                адресу: 601125, Владимирская область, Петушинский район, п.Вольгинский, ул. Заводская, стр. 273, свое
                согласие на обработку персональных данных (далее - «Персональные данные») в соответствии со следующими
                условиями:
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                1. Настоящее Согласие предоставлено на обработку Персональных данных, как без использования средств
                автоматизации, так и с их использованием.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>2. Настоящее Согласие предоставлено на обработку следующих Персональных данных:</p>
              <ol>
                <li>персональные данные, не являющиеся специальными или биометрическими:</li>
              </ol>
              <ol>
                <li>ФИО, пол, дата рождения;</li>
              </ol>
              <ol>
                <li>Контактные данные: email, номер телефона;</li>
              </ol>
              <ol>
                <li>Сведения о гражданстве и месте проживания;</li>
              </ol>
              <ol>
                <li>Сведения об образовании: место учебы, специальность, средний балл, год выпуска;</li>
              </ol>
              <ol>
                <li>
                  Сведения и профессиональной деятельности: места работы и должности, даты и продолжительность работы в
                  той или иной компании;
                </li>
              </ol>
              <ol>
                <li>
                  Сведения о воинском учете; сведений о наличии/отсутствии водительского удостоверения, загранпаспорта;
                </li>
              </ol>
              <ol>
                <li>Иные данные, размещаемые Вами в форме резюме</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>3. Персональные данные не являются общедоступными.</p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>4. Цель обработки Персональных данных:</p>
              <ol>
                <li>Рассмотрение кандидата на вакантную должность.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>5. Основаниями для обработки Персональных данных являются:</p>
              <ol>
                <li>статья 24 Конституции Российской Федерации;</li>
              </ol>
              <ol>
                <li>статья 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данны»;</li>
              </ol>
              <ol>
                <li>согласие на обработку персональных данных.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>6. В ходе обработки Персональных данных могут быть совершены следующие действия:</p>
              <ol>
                <li>сбор;</li>
              </ol>
              <ol>
                <li>запись;</li>
              </ol>
              <ol>
                <li>систематизация;</li>
              </ol>
              <ol>
                <li>накопление;</li>
              </ol>
              <ol>
                <li>хранение;</li>
              </ol>
              <ol>
                <li>уточнение (обновление, изменение);</li>
              </ol>
              <ol>
                <li>извлечение;</li>
              </ol>
              <ol>
                <li>использование;</li>
              </ol>
              <ol>
                <li>удаление;</li>
              </ol>
              <ol>
                <li>уничтожение;</li>
              </ol>
              <ol>
                <li>блокирование;</li>
              </ol>
              <ol>
                <li>передача (распространение, предоставление, доступ).</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Кроме того, настоящим лицо дает согласие на поручение обработки своих Персональных данных третьим лицам
                для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                7. Настоящее Согласие дается в том числе на возможную передачу Обществом Персональных данных третьим
                лицам, оказывающим услуги Обществу для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                8. Персональные данные обрабатываются Обществом до достижения целей обработки, либо до момента получения
                от лица соответствующего письменного заявления об отзыве Согласия на обработку персональных данных.
                После этого Персональные данные уничтожаются в срок, не превышающий 12 календарных месяцев.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                9. Настоящее Согласие может быть отозвано путем направления письменного заявления в Общество по адресу,
                указанному во вводном абзаце данного Согласия, а также путем направления письменного заявления{' '}
                <a style={{ color: 'blue' }} href='mailto:career@generium.ru'>
                  career@generium.ru
                </a>
                .
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                10. В случае отзыва субъектом персональных данных или его представителем Согласия на обработку
                персональных данных Общество вправе продолжить обработку персональных данных без согласия субъекта
                персональных данных в случаях, предусмотренных законодательством.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11. Настоящее Согласие действует до момента прекращения обработки персональных данных, указанных в
                пунктах 8 и 9 данного Согласия.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_title}>Приложение № 2 к Политике обработки персональных данных</p>
          <p className={styles.right_item1_p}>Согласие на обработку персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Лицо, заполняющее контактную форму, размещенную на настоящем ресурсе, для целей участия в конкурсе на
                вакантную должность, настоящим дает компании АО «Генериум» (далее - «Общество»), зарегистрированному по
                адресу: 601125, Владимирская область, Петушинский район, п.Вольгинский, ул. Заводская, стр. 273, свое
                согласие на обработку персональных данных (далее - «Персональные данные») в соответствии со следующими
                условиями:
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                1. Настоящее Согласие предоставлено на обработку Персональных данных, как без использования средств
                автоматизации, так и с их использованием.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>2. Настоящее Согласие предоставлено на обработку следующих Персональных данных:</p>
              <ol>
                <li>персональные данные, не являющиеся специальными или биометрическими:</li>
              </ol>
              <ol>
                <li>ФИО, пол, дата рождения;</li>
              </ol>
              <ol>
                <li>Контактные данные: email, номер телефона;</li>
              </ol>
              <ol>
                <li>Сведения о гражданстве и месте проживания;</li>
              </ol>
              <ol>
                <li>
                  Сведения об образовании: место учебы, факультет, кафедра, специальность, средний балл, год выпуска,
                  либо текущий курс обучения;
                </li>
              </ol>
              <ol>
                <li>
                  Сведения и профессиональной деятельности: места работы и должности, даты и продолжительность работы в
                  той или иной компании;
                </li>
              </ol>
              <ol>
                <li>
                  Сведения о воинском учете; сведений о наличии/отсутствии водительского удостоверения, загранпаспорта;
                </li>
              </ol>
              <ol>
                <li>Иные данные, размещаемые Вами в форме резюме</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>3. Персональные данные не являются общедоступными.</p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>4. Цель обработки Персональных данных:</p>
              <ol>
                <li>Рассмотрение кандидата на вакансию стажера.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>5. Основаниями для обработки Персональных данных являются:</p>
              <ol>
                <li>статья 24 Конституции Российской Федерации;</li>
              </ol>
              <ol>
                <li>статья 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данны»;</li>
              </ol>
              <ol>
                <li>согласие на обработку персональных данных.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>6. В ходе обработки Персональных данных могут быть совершены следующие действия:</p>
              <ol>
                <li>сбор;</li>
              </ol>
              <ol>
                <li>запись;</li>
              </ol>
              <ol>
                <li>систематизация;</li>
              </ol>
              <ol>
                <li>накопление;</li>
              </ol>
              <ol>
                <li>хранение;</li>
              </ol>
              <ol>
                <li>уточнение (обновление, изменение);</li>
              </ol>
              <ol>
                <li>извлечение;</li>
              </ol>
              <ol>
                <li>использование;</li>
              </ol>
              <ol>
                <li>удаление;</li>
              </ol>
              <ol>
                <li>уничтожение;</li>
              </ol>
              <ol>
                <li>блокирование;</li>
              </ol>
              <ol>
                <li>передача (распространение, предоставление, доступ).</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Кроме того, настоящим лицо дает согласие на поручение обработки своих Персональных данных третьим лицам
                для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                7. Настоящее Согласие дается в том числе на возможную передачу Обществом Персональных данных третьим
                лицам, оказывающим услуги Обществу для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                8. Персональные данные обрабатываются Обществом до достижения целей обработки, либо до момента получения
                от лица соответствующего письменного заявления об отзыве Согласия на обработку персональных данных.
                После этого Персональные данные уничтожаются в срок, не превышающий 12 календарных месяцев.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                9. Настоящее Согласие может быть отозвано путем направления письменного заявления в Общество по адресу,
                указанному во вводном абзаце данного Согласия, а также путем направления письменного заявления{' '}
                <a style={{ color: 'blue' }} href='mailto:career@generium.ru'>
                  career@generium.ru
                </a>
                .
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                10. В случае отзыва субъектом персональных данных или его представителем Согласия на обработку
                персональных данных Общество вправе продолжить обработку персональных данных без согласия субъекта
                персональных данных в случаях, предусмотренных законодательством.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11. Настоящее Согласие действует до момента прекращения обработки персональных данных, указанных в
                пунктах 8 и 9 данного Согласия.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.right_item1}>
          <p className={styles.right_item1_title}>Приложение № 3 к Политике обработки персональных данных</p>
          <p className={styles.right_item1_p}>Согласие на обработку персональных данных</p>

          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Лицо, заполняющее контактную форму, размещенную на настоящем ресурсе, для целей участия в конкурсе на
                вакантную должность, настоящим дает компании АО «Генериум» (далее - «Общество»), зарегистрированному по
                адресу: 601125, Владимирская область, Петушинский район, п.Вольгинский, ул. Заводская, стр. 273, свое
                согласие на обработку персональных данных (далее - «Персональные данные») в соответствии со следующими
                условиями:
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                1. Настоящее Согласие предоставлено на обработку Персональных данных, как без использования средств
                автоматизации, так и с их использованием.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>2. Настоящее Согласие предоставлено на обработку следующих Персональных данных:</p>
              <ol>
                <li>персональные данные, не являющиеся специальными или биометрическими:</li>
              </ol>
              <ol>
                <li>ФИО, пол, дата рождения;</li>
              </ol>
              <ol>
                <li>Контактные данные: email, номер телефона;</li>
              </ol>
              <ol>
                <li>Сведения о гражданстве и месте проживания;</li>
              </ol>
              <ol>
                <li>
                  Сведения об образовании: место учебы, факультет, кафедра, специальность, средний балл, год выпуска,
                  либо текущий курс обучения;
                </li>
              </ol>
              <ol>
                <li>
                  Сведения и профессиональной деятельности: места работы и должности, даты и продолжительность работы в
                  той или иной компании;
                </li>
              </ol>
              <ol>
                <li>
                  Сведения о воинском учете; сведений о наличии/отсутствии водительского удостоверения, загранпаспорта;
                </li>
              </ol>
              <ol>
                <li>Иные данные, размещаемые Вами в форме резюме</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>3. Персональные данные не являются общедоступными.</p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>4. Цель обработки Персональных данных:</p>
              <ol>
                <li>Рассмотрение кандидата на участие в образовательной программе «Mabstudy»</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>5. Основаниями для обработки Персональных данных являются:</p>
              <ol>
                <li>статья 24 Конституции Российской Федерации;</li>
              </ol>
              <ol>
                <li>статья 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данны»;</li>
              </ol>
              <ol>
                <li>согласие на обработку персональных данных.</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>6. В ходе обработки Персональных данных могут быть совершены следующие действия:</p>
              <ol>
                <li>сбор;</li>
              </ol>
              <ol>
                <li>запись;</li>
              </ol>
              <ol>
                <li>систематизация;</li>
              </ol>
              <ol>
                <li>накопление;</li>
              </ol>
              <ol>
                <li>хранение;</li>
              </ol>
              <ol>
                <li>уточнение (обновление, изменение);</li>
              </ol>
              <ol>
                <li>извлечение;</li>
              </ol>
              <ol>
                <li>использование;</li>
              </ol>
              <ol>
                <li>удаление;</li>
              </ol>
              <ol>
                <li>уничтожение;</li>
              </ol>
              <ol>
                <li>блокирование;</li>
              </ol>
              <ol>
                <li>передача (распространение, предоставление, доступ).</li>
              </ol>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                Кроме того, настоящим лицо дает согласие на поручение обработки своих Персональных данных третьим лицам
                для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                7. Настоящее Согласие дается в том числе на возможную передачу Обществом Персональных данных третьим
                лицам, оказывающим услуги Обществу для достижения целей, указанных в пункте 4 настоящего Согласия.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                8. Персональные данные обрабатываются Обществом до достижения целей обработки, либо до момента получения
                от лица соответствующего письменного заявления об отзыве Согласия на обработку персональных данных.
                После этого Персональные данные уничтожаются в срок, не превышающий 12 календарных месяцев.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                9. Настоящее Согласие может быть отозвано путем направления письменного заявления в Общество по адресу,
                указанному во вводном абзаце данного Согласия, а также путем направления письменного заявления{' '}
                <a style={{ color: 'blue' }} href='mailto:career@generium.ru'>
                  career@generium.ru
                </a>
                .
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                10. В случае отзыва субъектом персональных данных или его представителем Согласия на обработку
                персональных данных Общество вправе продолжить обработку персональных данных без согласия субъекта
                персональных данных в случаях, предусмотренных законодательством.
              </p>
            </div>
          </div>
          <div className={styles.right_wrapper_item}>
            <img className={styles.right_circle} src={circle} alt='circle' />
            <div className={styles.right_wrap_li}>
              <p>
                11. Настоящее Согласие действует до момента прекращения обработки персональных данных, указанных в
                пунктах 8 и 9 данного Согласия.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
